export const PRICING_BATCH_INNER_TABLE_COLUMN_WIDTH_PX = {
    rowNumber: 48,
    sku: 220,
    productCategory: 150,
    store: 176,
    priceChangeScope: 110,
    competitorPrice: 170,
    proposedPrice: 170,
    interimPrice: 170,
    costPrice: 170,
    currentPrice: 170,
    currentMargin: 170,
    proposedMargin: 170,
    benchmarkMargin: 170,
    requestHistoryLabel: 340,
    futurePrices: 240,
    productSales: 170,
    dateRequested: 170,
    responseDate: 170,
    friendlyId: 92,
    advertisingZone: 144,
    priceDirection: 132,
    actions: 170,
} as const;

export const PRICING_BATCH_INNER_TABLE_SELECTION_COLUMN_WIDTH_PX = 48;
